export default function ContactSection() {
  return (
    <section id="contact" className="relative py-24 md:py-32 bg-enerverze-bg">
      <div className="w-full px-4 md:px-8 lg:px-12">
        <div className="rounded-3xl overflow-hidden mb-12 md:mb-16">
          <div className="relative">
            <img
              src="https://readdy.ai/api/search-image?query=AI%20powered%20smart%20grid%20energy%20platform%20visualization%20with%20holographic%20data%20displays%20and%20neon%20cyan%20energy%20flows%20on%20dark%20slate%20background%20futuristic%20control%20room%20interface%20high%20quality%203D%20render%20abstract%20technology&width=1400&height=600&seq=cta1&orientation=landscape"
              alt="AI 에너지 플랫폼"
              className="w-full h-64 md:h-96 object-cover object-center"
            />
            <div className="absolute inset-0 bg-gradient-to-b from-enerverze-bg/30 via-enerverze-bg/50 to-enerverze-bg/80"></div>
          </div>
        </div>

        <div className="text-center max-w-3xl mx-auto">
          <h2 className="text-3xl md:text-4xl lg:text-5xl font-bold leading-tight mb-6">
            <span className="text-enerverze-text">지속 가능한 </span>
            <span className="text-neon-cyan italic">에너지 미래</span>
            <span className="text-enerverze-text">를</span>
            <br />
            <span className="text-enerverze-text">함께 만들어요</span>
          </h2>
          <p className="text-base md:text-lg text-enerverze-muted leading-relaxed mb-10">
            에너버즈와 협력을 원하시거나, 제품 및 서비스에 대해 궁금하신 점이 있으시면
            <br className="hidden md:block" />
            언제든지 문의해 주세요. 에너지 혁신의 동반자가 되어 드리겠습니다.
          </p>

          <div className="flex flex-col sm:flex-row items-center justify-center gap-4">
            <a
              href="mailto:ccc62000@daum.net"
              className="inline-flex items-center gap-3 bg-enerverze-text text-enerverze-bg px-8 py-4 rounded-full text-base font-medium hover:bg-neon-cyan transition-colors group whitespace-nowrap"
            >
              <span>문의하기</span>
              <i className="ri-arrow-right-line text-neon-cyan group-hover:text-enerverze-bg transition-colors"></i>
            </a>
            <a
              href="tel:"
              className="inline-flex items-center gap-2 text-neon-cyan hover:text-neon-green text-sm font-medium transition-colors whitespace-nowrap"
            >
              <i className="ri-mail-line"></i>
              <span>ccc62000@daum.net</span>
            </a>
          </div>
        </div>
      </div>
    </section>
  );
}